module.exports = __webpack_public_path__ + "static/media/ic_pause.32bfb6e8.svg";